export type ClientOrderChatSender = 'CLIENT' | 'SUPER_ADMIN' | 'SYSTEM' | 'SELLER';

export type ClientOrderChatSystemEvent =
  | 'ORDER_PROBLEM'
  | 'ORDER_PROBLEM_RESOLVED'
  | 'SELLER_INVITED';

export interface ClientOrderChatMessage {
  id: number;
  threadId: number;
  senderKind: ClientOrderChatSender;
  body: string;
  imageUrls: string[];
  senderName: string | null;
  createdAt: string;
  systemEvent?: ClientOrderChatSystemEvent | null;
  orderId?: number | null;
  orderNumber?: string | null;
  relatedMessageId?: number | null;
  invitedSellerId?: number | null;
  invitedSellerName?: string | null;
}

export interface ClientOrderChatMessagesResponse {
  items: ClientOrderChatMessage[];
  total: number;
  threadId: number;
  problemMessageId: number;
  resolved: boolean;
}

export interface ClientOrderChatSession {
  problemMessageId: number;
  threadId: number;
  userId: number;
  userName: string | null;
  userPhone: string | null;
  orderId: number | null;
  orderNumber: string | null;
  resolved: boolean;
  lastMessage: ClientOrderChatMessage | null;
  unreadCount: number;
  updatedAt: string;
}

export interface ClientOrderChatSessionsResponse {
  items: ClientOrderChatSession[];
  total: number;
}

export interface ClientOrderChatMessageEvent {
  userId: number;
  userName: string | null;
  userPhone: string | null;
  message: ClientOrderChatMessage;
  problemMessageId?: number | null;
}

export const CLIENT_ORDER_CHAT_WS_NAMESPACE = '/client-support-chat';
export const CLIENT_ORDER_CHAT_WS_PATH = '/api/ws';

export const CLIENT_ORDER_CHAT_EVENTS = {
  messageNew: 'chat:message',
  unread: 'chat:unread',
} as const;

export const CLIENT_ORDER_CHAT_MAX_IMAGES = 5;

export function isSystemOrderChatMessage(message: ClientOrderChatMessage): boolean {
  return message.senderKind === 'SYSTEM' || Boolean(message.systemEvent);
}
